import React from 'react';
import { FieldController } from 'client/shared/FieldController';
import { FieldRadioToggle } from '.';
import {
  ControlledFieldRadioToggleProps,
  FieldRadioToggleProps,
} from './types';

export const ControlledFieldRadioToggle = (
  props: ControlledFieldRadioToggleProps
) => (
  // eslint-disable-next-line react/jsx-props-no-multi-spaces
  <FieldController<FieldRadioToggleProps, HTMLInputElement>
    as={FieldRadioToggle}
    {...props}
  />
);
